// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2978":"850b55bf","8948":"99ff3b57"}[chunkId] + ".chunk.css";
};